import { useCallback } from "react";
import { Button, Modal as BootstrapModal } from "react-bootstrap";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";

import Me from "../../services/me";
import TextBox from "../controls/form/TextBox";

const ResetPassword = ({
    show,
    onConfirm,
    onCancel
}) => {
    const [translate] = useTranslation();

    const resetPassword = useCallback(async ({ currentPassword, newPassword }, { setErrors }) => {
        const response = await Me.resetPassword({ currentPassword, newPassword });

        if (response.error) {
            // does not show prompt and will not refresh token
            if (response.status === 401) {
                setErrors({
                    currentPassword: translate("OTM_CURRENT_PASSWORD_INCORRECT")
                });
            }
        }
        else {
            onConfirm();
        }
    }, [onConfirm, translate]);

    return (
        <BootstrapModal show={show} backdrop="static">
            <Formik
                initialValues={{
                    currentPassword: "",
                    newPassword: "",
                    confirmPassword: ""
                }}
                validationSchema={Yup.object({
                    currentPassword: Yup.string().required(translate("OTM_CURRENT_PASSWORD_REQUIRED")),
                    newPassword: Yup.string().min(4, translate("OTM_CHARACTERS_OR_MORE", { minCharacters: 4 })).required(translate("OTM_PASSWORD_REQUIRED")),
                    confirmPassword: Yup.string().oneOf([Yup.ref("newPassword")], translate("OTM_PASSWORD_SHOULD_MATCH")).required(translate("OTM_CONFIRM_PASSWORD_REQUIRED"))
                })}
                onSubmit={resetPassword}
                enableReinitialize
                validateOnMount
            >
                {(props) => (
                    <Form>
                        <BootstrapModal.Header className="h5 text-secondary">
                            {translate("OTM_RESET_PASSWORD")}
                        </BootstrapModal.Header>
                        <BootstrapModal.Body>
                            <TextBox
                                label={translate("OTM_CURRENT_PASSWORD")}
                                isRequired={true}
                                type="password"
                                name="currentPassword"
                                css="mt-3"
                            />
                            <TextBox
                                label={translate("OTM_NEW_PASSWORD")}
                                isRequired={true}
                                type="password"
                                name="newPassword"
                                css="mt-3"
                            />
                            <TextBox
                                label={translate("OTM_CONFIRM_PASSWORD")}
                                isRequired={true}
                                type="password"
                                name="confirmPassword"
                                css="mt-3"
                            />
                        </BootstrapModal.Body>
                        <BootstrapModal.Footer>
                            <Button
                                type="submit"
                                className="btn-sm"
                                disabled={!props.isValid}
                            >
                                {translate("OTM_RESET_PASSWORD")}
                            </Button>
                            <Button
                                onClick={onCancel}
                                variant="secondary"
                                className="btn-sm"
                            >
                                {translate("OTM_CANCEL")}
                            </Button>
                        </BootstrapModal.Footer>
                    </Form>
                )}
            </Formik>
        </BootstrapModal>
    );
};

export default ResetPassword;